import { DepositMode } from 'services/recharges/recharges.config';
import { WithdrawalMode } from 'services/withdrawal/withdrawal.config';

export enum monthTranslate {
  'lbl.month.january' = 1,
  'lbl.month.february',
  'lbl.month.march',
  'lbl.month.april',
  'lbl.month.may',
  'lbl.month.june',
  'lbl.month.july',
  'lbl.month.august',
  'lbl.month.september',
  'lbl.month.october',
  'lbl.month.november',
  'lbl.month.december',
}

export const idTracingMap = {
  /****** SidebarNav *******/
  SidebarNav: {
    Dashboard: 'SidebarNav_Dashboard',
    Profile: 'SidebarNav_Profilo',
    Movements: 'SidebarNav_Movimenti_conto',
    Bonus: 'SidebarNav_I_tuoi_bonus',
    BonusWager: 'SidebarNav_I_tuoi_bonus_Wager',
    InviteFriends: 'SidebarNav_Invita_Amici',
    Inbox: 'SidebarNav_Messaggi',
    Preferences: 'SidebarNav_Preferenze',
    PlayResponsibly: 'SidebarNav_Gioca_il_Giusto',
    RechargeButton: 'SidebarNav_Ricarica',
    WithdrawButton: 'SidebarNav_Preleva',
  },
  /****** ProfileCard - Profilo su Dashboard *******/
  ProfileCard: {
    SeeAll: 'Profilo_Vedi_tutti',
    Username: 'Profilo_Username',
    FiscalCode: 'Profilo_Codice_fiscale',
    PinNumber: 'Profilo_Pin_conto',
    AccountNumber: 'Profilo_Numero_conto',
  },
  /****** LoyaltyBonusCard - Loyalty Bonus su Dashboard *******/
  LoyaltyBonusCard: {
    sisalPoints: 'LoyaltyBonusCard_sisalPoints',
    monthlyReward: 'LoyaltyBonusCard_monthlyReward',
    bimonthlyStatusPoints: 'LoyaltyBonusCard_bimestrePoints',
    monthlyStatusPoints: 'LoyaltyBonusCard_monthlyStatusPoints',
  },
  /****** CardRechargeWithdrawComponent - Gestisci il saldo su Dashboard *******/
  CardRechargeWithdrawComponent: {
    Withdraw: 'Widget_GestisciSaldo_Preleva',
    Recharge: 'Widget_GestisciSaldo_Ricarica',
  },
  /****** TableLastMovements - Ultimi x movimenti su Dashboard *******/
  TableLastMovements: {
    BaseUrl: 'ID_UltimiMovimenti',
    SeeAll: 'ID_UltimiMovimenti_Vedi_tutti',
  },
  /****** Generics shared across tables *******/
  TableGenerics: {
    SeeAll: 'Vedi_tutti', //
    Date: 'Data',
    TimeLong: 'OraEstesa',
    TimeShort: 'OraBreve',
    Category: 'Categoria', //Search for _Default in TableRowCustom, that should be this with proper typeAction.
    Description: 'Descrizione',
    Amount: 'Importo',
    ButtonReceipt: 'PulsanteRicevuta',
    TSN: 'TSN',
  },
  /****** UserAccessData - Dati di accesso *******/
  UserAccessData: {
    AccountNumber: 'DatiAccesso_Numero_conto',
    PinNumber: 'DatiAccesso_Pin_conto',
    Username: 'DatiAccesso_Username',
    Modify: 'DatiAccesso_Modifica',
    ErrorMessage: 'DatiAccesso_Messaggio_di_errore',
    SaveButton: 'DatiAccesso_Salva',
    Cancel: 'DatiAccesso_Annulla',
  },
  /****** UserContacts - Recapiti *******/
  UserContacts: {
    TelephoneLabel: 'Recapiti_Telefono',
    EmailLabel: 'Recapiti_Email',
    Modify: 'Recapiti_Modifica',
    NationalPrefix: 'Recapiti_Nazione',
    TelephoneInput: 'Recapiti_Telefono_input',
    EmailInput: 'Recapiti_Email_input',
    SaveButton: 'Recapiti_Salva',
    Cancel: 'Recapiti_Annulla',
  },
  /****** UserAnagraphic - Dati anagrafici *******/
  UserAnagraphic: {
    Name: 'Dati_Anagrafici_Nome',
    Surname: 'Dati_Anagrafici_Cognome',
    FiscalCode: 'Dati_Anagrafici_Codice_fiscale',
    BirthDate: 'Dati_Anagrafici_Data_di_nascita',
    BirthCity: 'Dati_Anagrafici_Comune_di_nascita',
    BirthCountry: 'Dati_Anagrafici_Paese_di_nascita',
  },
  /****** UserResidence - Residenza *******/
  UserResidence: {
    Country: 'Residenza_Paese',
    City: 'Residenza_Comune',
    ZipCode: 'Residenza_Cap',
    Address: 'Residenza_Indirizzo',
  },
  /****** UserPassword - Password *******/
  UserPassword: {
    Password: 'Password',
    Modify: 'Modifica_password',
    SaveButton: 'Salva_password',
    Cancel: 'Annulla_password',
  },
  /****** UserSensitiveData - Sicurezza *******/
  UserSensitiveData: {
    QuestionLabel: 'Sicurezza_Domanda',
    AnswerLabel: 'Sicurezza_Risposta',
    Modify: 'Sicurezza_Modifica',
    Question: 'Sicurezza_Domanda_input',
    Answer: 'Sicurezza_Risposta_input',
    ErrorMessage: 'Sicurezza_Messaggio_di_errore',
    SaveButton: 'Sicurezza_Salva',
    Cancel: 'Sicurezza_Annulla',
  },
  /****** UserDownloadContract - Contratto di gioco *******/
  UserDownloadContract: {
    DownloadButton: 'Scarica_Contratto',
  },
  /****** UserDocument - Documento *******/
  UserDocument: {
    Status: 'Stato_documento',
    ExpiringDate: 'Data_di_scadenza',
  },
  /****** UserDomicile - Domicilio *******/
  UserDomicile: {
    CountryLabel: 'Domicilio_Paese',
    CityLabel: 'Domicilio_Comune',
    ZipCodeLabel: 'Domicilio_Cap',
    AddressLabel: 'Domicilio_Indirizzo',
    Modify: 'Domicilio_Modifica',
    Country: 'Domicilio_Paese_input',
    CountryErrorMessage: 'Domicilio_Msg_err_Paese',
    City: 'Domicilio_Comune_input',
    CityErrorMessage: 'Domicilio_Msg_err_Comune',
    ZipCode: 'Domicilio_Cap_input',
    ZipCodeErrorMessage: 'Domicilio_Msg_errore_Cap',
    Address: 'Domicilio_Indirizzo_input',
    AddressErrorMessage: 'Domicilio_Msg_errore_indirizzo',
    SaveButton: 'Domicilio_Salva',
    Cancel: 'Domicilio_Annulla',
    Discrict: 'Distretto',
  },
  /****** UserPhoneNumber - Contatto telefonico *******/
  UserPhoneNumber: {
    TelephoneLabel: 'Numero_Telefono',
    TelephoneInput: 'Numero_Telefono_telefono_input',
    NationalPrefix: 'Numero_Telefono_Nazione',
    Verify: 'Numero_Telefono_Verifica',
    Modify: 'Numero_Telefono_Modifica',
    SaveButton: 'Numero_Telefono_Salva',
    Cancel: 'Numero_Telefono_Annulla',
  },
  /****** UserMail - Indirizzo email *******/
  UserEmail: {
    EmailLabel: 'Email_email',
    EmailInput: 'Email_email_input',
    Verify: 'Email_Verifica',
    Modify: 'Email_Modifica',
    SaveButton: 'Email_Salva',
    Cancel: 'Email_Annulla',
  },
  /****** AmountPlayedNotification - Notifica importa giocato *******/
  AmountPlayedNotification: {
    Checkbox: 'Notifica_Checkbox',
  },
  /****** TemporaryExclusion - Autoesclusione Temporanea *******/
  TemporarySelfExclusion: {
    PeriodSelect: 'Autoesc_temp_Seleziona_periodo',
    SaveButton: 'Autoesc_temp_Salva',
  },
  /****** PermanentExclusion - Autoesclusione permanente *******/
  PermanentSelfExclusion: {
    Checkbox: 'Autoesc_perm_Checkbox',
    SaveButton: 'Autoesc_perm_Salva',
  },
  /****** SignedInUserToolbar - ExpandedVariant *******/
  SignedInUserToolbar: {
    EV_RealBonus: 'Header_Real_Bonus',
    EV_Balance: 'Header_Saldo',
    EV_RechargeButton: 'Header_Ricarica',
    EV_RefreshButton: 'Header_RefreshButton',
    EV_HeartButton: 'Header_HeartButton',
    EV_ProfileButton: 'Header_ProfileButton',
  },
  /****** FormRecharge generic IDs *******/
  FormRecharge: {
    Pin: 'PIN',
    PinErrorMessage: 'Messaggio_di_errore_PIN',
    AmountField: 'Ricarica_Input',
    PromoCode: 'Codice_promozionale',
    Email: 'Indirizzo_email',
  },

  MethodCardRecharge: {
    [DepositMode.default]: 'Method_Default',
    [DepositMode.pdV]: 'Method_PuntoDiVendita',
    [DepositMode.postePostpay]: 'Method_PostePay',
    [DepositMode.safeChargeVisa]: 'Method_Visa',
    [DepositMode.safeChargeMasterCard]: 'Method_Mastercard',
    [DepositMode.safeChargeSkrill]: 'Method_Skrill',
    [DepositMode.safeChargeSkrillOneTap]: 'Method_Skrill1Tap',
    [DepositMode.safeChargePaypal]: 'Method_Paypal',
    [DepositMode.safeChargeNeteller]: 'Method_Neteller',
    [DepositMode.bankTransfer]: 'Method_BonificoBancario',
    [DepositMode.safeChargePaysafe]: 'Method_PaysafeCard',
    [DepositMode.directBankTransfer]: 'Method_DirectBankTransfer',
    [DepositMode.applepay]: 'Method_applepay',
    [DepositMode.safeChargeMasterCardAutomaticActivation]:
      'Method_Mastercard_automatic',
    [DepositMode.safeChargeVisaAutomaticActivation]: 'Method_Visa_automatic',
    [DepositMode.voucherEpay]: 'Method_VoucherEpay',
    [DepositMode.mbWay]: 'Method_MB_Way',
    [DepositMode.multibanco]: 'Method_Multibanco',
    [DepositMode.bizum]: 'Method_Bizum',
  },

  MethodCardWithdrawal: {
    [WithdrawalMode.bankTransfer]: 'Method_bankTransfer',
    [WithdrawalMode.posteContoBPOL]: 'Method_posteContoBPOL',
    [WithdrawalMode.postePostpay]: 'Method_postePostpay',
    [WithdrawalMode.safeChargeMasterCard]: 'Method_safeChargeMasterCard',
    [WithdrawalMode.safeChargeVisa]: 'Method_safeChargeVisa',
    [WithdrawalMode.safeChargeSkrill]: 'Method_safeChargeSkrill',
    [WithdrawalMode.applepay]: 'Method_applepay',
    [WithdrawalMode.directBankTransfer]: 'Method_DirectBankTransfer',
    [WithdrawalMode.safeChargePaypal]: 'Method_safeChargePaypal',
    [WithdrawalMode.safeChargeNeteller]: 'Method_safeChargeNeteller',
  },
};

export const AppChannel = {
  VecchiaApr: 0,
  PortaleWebWwwSisalIt: 1,
  PortaleGiochiNumerici: 2,
  MSiteMSisalIt: 3,
  Totem: 4,
  MSiteScommesse: 5,
  AppMobileMobileSisalIt: 6,
  AppMobileLitGrattaEVinci: 7,
  AppMobileGame360: 8,
  ClientBingo: 9,
  ClientPoker: 10,
  SkillGamesGameAccount: 11,
  ClientCasinoGamesPt: 12,
  QuickGamesWeb: 13,
  NonAuthoritativeSites: 14,
  SkillGamesLtmWeb: 15,
  CasinoGamesGameAccount: 16,
  PortaleLoyaltyKeyos: 17,
  PortaleGiochiNumerici2: 18,
  QuickGamesMobile: 19,
  WebLotto10ELotto: 20,
  MobileLotto10ELotto: 21,
  WebVirtualRacesOnline: 22,
  AppMobileSuperenalotto: 24,
  MobileSiteCasinoGamesGameAccount: 25,
  SkillGamesLtmMobile: 26,
  AppMobileLitGrattaEVinci2: 28,
  AppFantasySlotGame360: 29,
  AppMobileVirtualRace: 30,
  MobileClientCasinoGamesPt: 31,
  AppMobileVinciCasa: 32,
  AppMobileCasinoGamesViaden: 33,
  ClientCasinoActiveGames: 34,
  AppMobileMobileSisalItIpad: 35,
  CasinoGamesGiocaOnLine: 36,
  AppMobileNativeCasinoAppPlaytech: 37,
  AppMobileClassicSlotGameAccount: 38,
  AppMobileLiveScoreScoreAlarm: 39,
  CasinoGamesGame360: 40,
  PlaytechNativePokerApp: 41,
  IppicaBetflag: 42,
  MobileCasinoGamesGame360: 43,
  AppMobileEuroJackpot: 44,
  AppMobileBingo: 45,
  MediasetDtt: 46,
  AppMobileRouletteGameAccount: 47,
  AppMobileCasinoGamesGame360Macau: 48,
  AppRouletteGiocaOnLine: 49,
  RouletteGiocaOnLineMsite: 50,
  AppMobileScommesse: 51,
  GamificationPugPharmDesktop: 52,
  GamificationPugPharmMobile: 53,
  AppLottery: 54,
  AppCasinoHub: 55,
  MobileSiteVirtualRace: 56,
  MobileSitePoker: 57,
  AppSisalGame360: 59,
  MobileSiteBetflag: 60,
  AppMobileBetflag: 61,
  PortaleWebFullResponsiveWwwSisalIt: 62,
  AppMobileLdtLotteriaItalia: 63,
  SisalFunClub: 64,
  SalvaIlBottino: 65,
  ClientDesktopSisalPoker: 67,
  AppSisalPoker: 68,
} as const;

export type Application = keyof typeof AppChannel;
export type Channel = (typeof AppChannel)[Application];
